<template>
  <section class="pond-box">
    <h5> {{ data.title }} </h5>
    <h6 class="pond-box__subtitle">
      {{ data.subtitle }}
      </h6>
    <p class="pond-box__number">
      {{ data.number }}
      <span>kr/m</span>
    </p>
  </section>
</template>

<script>
export default {
  name: 'DataBox',
  props: [ 'data' ],
}
</script>

<style lang="scss" scoped>
.pond-box {
  padding: 1.5rem;
  background-color: $light;
  border-radius: $borderRadius;
  margin-bottom: 1rem;

  &__subtitle {
    color: $mainTextColor;
    font-family: "Roboto-Light", sans-serif;
    font-size: 1rem;
    line-height: 1.3em;
    margin: 0;
    text-transform: none;
    letter-spacing: normal;
    font-weight: normal;
    margin-top: 1rem;
  }

  &__number {
    font-size: 2.5rem;
  }
}
</style>